var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift-list-box"},[_c('h4',[_vm._v("奖品一览")]),_c('div',{staticClass:"scroll-box"},_vm._l((_vm.giftListData),function(item,index){return _c('div',{key:index,staticClass:"gift-list-item"},[_c('img',{attrs:{"src":item.prizePicture}}),_c('span',[_vm._v(_vm._s(item.prizeName))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }